import { css } from '@emotion/react';
import { FormattedMessage } from 'react-intl';

import Tooltip from '@atlaskit/tooltip';
import { RelativeDate } from '@atlassian/bitkit-date';

import PullRequestSummary from 'src/components/pull-requests-table/item-info';
import PullRequestRefBranch from 'src/components/pull-requests-table/pull-request-ref-branch';
import * as styles from 'src/components/pull-requests-table/pull-request-row.style';
import { UserAvatar } from 'src/containers/user-avatar';
import { UserName } from 'src/containers/user-name';
import { SubtleLink } from 'src/styles';
import { PullRequest } from 'src/types/pull-requests-table';

import { messages } from '../merge-queues.i18n';

const TooltipBoundaries = css({
  width: '250px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

export const MergeQueuePullRequestSummary = ({
  pullRequest,
}: {
  pullRequest: PullRequest;
}) => {
  return (
    <PullRequestSummary
      key={pullRequest.id}
      avatar={
        <UserAvatar
          profileCardPosition="bottom-start"
          user={pullRequest.author}
        />
      }
      byline={
        <FormattedMessage
          {...messages.pullRequestByLine}
          values={{
            author: (
              <UserName
                key={`pr-row-${pullRequest.id}`}
                linkComponent={SubtleLink}
                profileCardPosition="bottom-start"
                user={pullRequest.author}
              />
            ),
            date: (
              <RelativeDate
                key={`date-key-${pullRequest.id}`}
                date={new Date(pullRequest.updated_on)}
              />
            ),
            id: pullRequest.id,
          }}
        >
          {(...args) => <styles.BylineNoMargin>{args}</styles.BylineNoMargin>}
        </FormattedMessage>
      }
      header={
        <styles.SummaryHeader>
          <Tooltip content={pullRequest.title}>
            <div css={TooltipBoundaries}>
              <styles.HeaderLink
                qaId="pull-request-row-link"
                title={pullRequest.title}
                href={pullRequest.links.html.href}
                isFocused={false}
                disableNativeTooltip
                target="_blank"
              >
                {pullRequest.title}
              </styles.HeaderLink>
            </div>
          </Tooltip>
          <styles.BranchesContainer>
            <styles.Branch>
              <PullRequestRefBranch pullRequestRepo={pullRequest.source} />
            </styles.Branch>
          </styles.BranchesContainer>
        </styles.SummaryHeader>
      }
    />
  );
};
